import { render, staticRenderFns } from "./lab-product-form.vue?vue&type=template&id=2837ab12"
import script from "./lab-product-form.vue?vue&type=script&lang=js"
export * from "./lab-product-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports